import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

import { JarvisWidget } from '../../../components';

class ChartReviewQueueReport extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    fetchData: PropTypes.func,
    isSuperAdmin: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { pageSize: 12 };
  }

  renderProvider = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className="provider pull-right">
      <AsyncSelect
        cacheOptions
        defaultOptions
        isClearable
        loadOptions={search => this.props.searchUsers(search, '')}
        getOptionValue={option => option.id}
        getOptionLabel={option => `${option.firstName} ${option.lastName}`}
        placeholder="User&nbsp;Name…"
        styles={{
          control: styles => ({
            ...styles,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            minHeight: 22,
            minWidth: 160,
            WebkitTextFillColor: '#108ee9',
          }),
          dropdownIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          clearIndicator: styles => ({
            ...styles,
            padding: 2,
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99,
            color: '#108ee9'
          }),
        }}
        menuPlacement="top"
        onChange={this.onProviderFilterChange.bind(this)}
      />
    </div>
  );

  onProviderFilterChange(val) {
    this.props.change('provider', val);
    setTimeout(() => this.props.handleSubmit(this.submit)(), 0);
  }

  getData = () => {
    const { data } = this.props;

    return data
      ? [
          {
            label: 'Total VNRX (Daily)',
            day1: data.totalVNRX[0],
            day2: data.totalVNRX[1],
            day3: data.totalVNRX[2],
            day4: data.totalVNRX[3],
            day5: data.totalVNRX[4],
            day6: data.totalVNRX[5],
            day7: data.totalVNRX[6],
          },
          {
            label: 'Selected',
            day1: data.selected[0],
            day2: data.selected[1],
            day3: data.selected[2],
            day4: data.selected[3],
            day5: data.selected[4],
            day6: data.selected[5],
            day7: data.selected[6],
          },
          {
            label: 'Reviewed',
            day1: data.selected[0],
            day2: data.selected[1],
            day3: data.selected[2],
            day4: data.selected[3],
            day5: data.selected[4],
            day6: data.selected[5],
            day7: data.selected[6],
          },
        ]
      : [];
  };

  submit = vals => {
    const { onSubmit } = this.props;
    return onSubmit({ ...vals });
  };

  render() {
    const { isSuperAdmin, handleSubmit } = this.props;
    return (
      <div className="row">
        <div className="col-md-12">
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>{' '}
              <h2>Chart Review Queue Report</h2>
            </header>
            <div>
              <div className="widget-body no-padding">
                {isSuperAdmin && (
                  <form
                    onSubmit={handleSubmit(this.submit)}
                    className="clearfix"
                    style={{ padding: '5px' }}
                  >
                    <Field
                      name="provider"
                      className="form-control"
                      component={this.renderProvider}
                      label="Provider"
                    />
                  </form>
                )}
                <ReactTable
                  loading={this.props.isLoading}
                  data={this.getData()}
                  columns={[
                    {
                      Header: '',
                      id: 'label',
                      accessor: 'label',
                      filterable: false,
                      width: 160,
                      Cell: row => <strong>{row.original.label}</strong>,
                    },
                    {
                      Header: '1 Day',
                      id: 'day1',
                      accessor: 'day1',
                      width: '11%',
                    },
                    {
                      Header: '2 Days',
                      id: 'day2',
                      accessor: 'day2',
                      width: '11%',
                    },
                    {
                      Header: '3 Days',
                      id: 'day3',
                      accessor: 'day3',
                      width: '11%',
                    },
                    {
                      Header: '4 Days',
                      id: 'day4',
                      accessor: 'day4',
                      width: '11%',
                    },
                    {
                      Header: '5 Days',
                      id: 'day5',
                      accessor: 'day5',
                      width: '11%',
                    },
                    {
                      Header: '6 Days',
                      id: 'day6',
                      accessor: 'day6',
                      width: '11%',
                    },
                    {
                      Header: '7+ Days',
                      id: 'day7',
                      accessor: 'day7',
                      width: '11%',
                    },
                  ]}
                  showPagination={false}
                  defaultPageSize={this.state.pageSize}
                  onPageSizeChange={pageSize => this.setState({ pageSize })}
                  className="-striped -highlight"
                />
              </div>
            </div>
          </JarvisWidget>
        </div>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  return errors;
};

export default connect(state => ({
  initialValues: {},
  validate,
}))(reduxForm({ form: 'chartReviewQueueReportForm' })(ChartReviewQueueReport));



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/ChartReviewQueueReport.js